import { RESTRICTION_TYPE, RestrictionDTO } from '../types/restriction'

type CreateRestrictionsParams = {
  parentFieldName?: string | null
  fieldName: string
  fieldCode: string
  viewId: string
  restrictionType: RESTRICTION_TYPE

  sortDirection?: 'asc' | 'desc' | null
  columnToSort?: string
  priority?: number
  show?: boolean
  width?: number
  order?: number
  fix?: string
}

export const createRestrictions = ({
  parentFieldName = null,
  fieldName,
  fieldCode,
  viewId,
  restrictionType,
  sortDirection,
  columnToSort,
  priority,
  show,
  width,
  order,
  fix,
}: CreateRestrictionsParams): RestrictionDTO => {
  let value

  switch (restrictionType) {
    case RESTRICTION_TYPE.SORT:
      value = `${columnToSort}//${sortDirection}//${priority ?? 0}`
      break

    case RESTRICTION_TYPE.SHOW:
      value = show ?? true
      break

    case RESTRICTION_TYPE.WIDTH:
      value = width
      break

    case RESTRICTION_TYPE.ORDER:
      value = order ?? 0
      break

    case RESTRICTION_TYPE.FIX:
      value = fix
      break

    default:
      value = {}
  }

  return {
    parentFieldName,
    fieldName,
    fieldCode,
    viewId,
    restrictionType,
    value,
  }
}
